import { Map } from 'immutable';
import { createSelector } from 'reselect';

import * as FPAIConstants from './constants';
import * as D from './deps';

export function getFamilyAcceptInviteState(state) {
  return state.familyPlanAcceptInvite || Map();
}

export const getIsValidFamilyPlanInviteToken = createSelector(
  getFamilyAcceptInviteState,
  D.PaymentsProtectedUtils.getPropFromMap(
    FPAIConstants.ReducerKeys.IS_VALID_FAMILY_PLAN_INVITE_TOKEN,
  ),
);

export const getFamilyPlanInviteToken = createSelector(
  getFamilyAcceptInviteState,
  D.PaymentsProtectedUtils.getPropFromMap(FPAIConstants.ReducerKeys.FAMILY_PLAN_INVITE_TOKEN),
);

export function isInFamilyPlanInviteeFlow(state) {
  return !!getFamilyPlanInviteToken(state);
}
